<template>
   <div id="modal" :class="['modal', modalPosition]">
    <div class="modal__content" :style="size">
      <div class="modal__close">
        <slot name="progressBar"></slot>
        <span id="modal-btn-close" class="di di-icon-close" @click="modalChangeDisplay"></span>
      </div>
      <div class="content__data">
      <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
  name: 'Modal',
  props: {
    modalPosition: {
      type: String,
      default: 'position--center'
    },
    size: {
      type: Object,
      default: () => ({ height: '335px', width: '330px' }),
    }
  },
  methods: {
    ...mapMutations({ defaultModal: 'SET_MODAL_DISPLAY' }),
    modalChangeDisplay() {
      this.defaultModal(false);
    }
  },
};
</script>
<style lang="scss" scoped>
.position--center {
  align-items: center;
  justify-content: center;
  .modal__content {
    max-width: 95%;
  }
}

.position--bottom {
  align-items: flex-end;
  justify-content: center;
  .modal__content {
    max-width: 100%;
  }
}

.position--top {
  align-items: flex-start;
  justify-content: center;
  .modal__content {
    max-width: 100%;
  }
}

.modal {
  display: flex;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  &__content {
    padding: 32px 0px;
    z-index:1;
    position: relative;
    border-radius: 4px;
    background-color: #FFFFFF;
    animation: moveUp .5s cubic-bezier(0.165, 0.840, 0.440, 1.000);
    min-height: 260px;
  }

  .content {
    &__data {
      grid-area: content;
      justify-self: center;
    }
  }

  &__close {
    grid-area: close;
    display: flex;
    flex-direction: column;
    width: 100%;
    .di-icon-close {
      padding: 8px 5px 0 12px;
      align-self: flex-end;
      &::before {
        width: fit-content;
        font-size: 14px;
        color: var(--color-grey-5);
      }
    }

    position: absolute;
    top: 0;
    right: 0;
    padding: 20px 16px 0 0;
  }
}

@keyframes moveUp {
  0% {
    transform:translateY(100%);
  }
  100% {
    transform:translateY(0);
  }
}
</style>
